import { useCallback, useEffect, useState } from "react";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import styles from "./driverreports.module.css";
import { TableLoader } from "../../../components/ContentLoader";
import { Calendar, Home, Search } from "react-feather";
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { DateRangePicker } from "rsuite";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import axios from "axios";
import dayjs from "dayjs";
import { CurrencyFormatter } from "../../../components/Helpers";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ButtonArea = ({ data }) => {
    const Export = ({ onExport }) => (<Button onClick={(e) => onExport(e.target.value)} className="TableAddBU" style={{ width: "auto" }}>Export To CSV</Button>);

    const convertArrayOfObjectsToCSV = (array) => {
        let result = "";

        const columnDelimiter = ",";
        const lineDelimiter = "\n";
        const keys = ["driver_id", "name", "total_assigned", "total_confirmed", "total_failed", "total_unpaid", "total_paid", "total_unpaid_amount", "total_paid_amount", "total_discount_amount", "total_amount"];

        keys.forEach((key) => {
            if (key === "driver_id") {
                result += "Driver Id";
            } else if (key === "name") {
                result += "Name";
            } else if (key === "total_assigned") {
                result += "Total Assigned Up";
            } else if (key === "total_confirmed") {
                result += "Confirmed Pickup";
            } else if (key === "total_failed") {
                result += "Failed Pickup";
            } else if (key === "total_unpaid") {
                result += "Total Unpaid";
            } else if (key === "total_paid") {
                result += " Total Paid";
            } else if (key === "total_unpaid_amount") {
                result += "Unpaid Amount";
            } else if (key === "total_paid_amount") {
                result += "Paid Amount";
            } else if (key === "total_discount_amount") {
                result += "Discounted Amount";
            } else if (key === "total_amount") {
                result += "Total Amount";
            } else {
                result += key;
            }
            result += columnDelimiter;
        });
        result += lineDelimiter;

        array.forEach((item) => {
            let ctr = 0;
            keys.forEach((key) => {
                if (ctr > 0) result += columnDelimiter;
                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        return result;
    }

    const downloadCSV = useCallback(() => {
        let newArray = data.map((row) => {
            return {
                driver_id: row?.driver_id,
                name: row?.name,
                total_assigned: row?.total_assigned,
                total_confirmed: row?.total_confirmed,
                total_failed: row?.total_failed,
                total_unpaid: row?.total_unpaid,
                total_paid: row?.total_paid,
                total_unpaid_amount: ((row?.total_amount && row?.total_paid_amount) ? parseFloat(row?.total_amount) - parseFloat(row?.total_paid_amount) : 0),
                total_paid_amount: (row?.total_paid_amount ? parseFloat(row?.total_paid_amount) : 0),
                total_discount_amount: (row?.total_discount_amount ? parseFloat(row?.total_discount_amount) : 0),
                total_amount: (row?.total_amount ? parseFloat(row?.total_amount) : 0)
            }
        });

        const link = document.createElement("a");
        let csv = convertArrayOfObjectsToCSV(newArray);
        if (csv == null) return;

        const filename = "driver-report.csv";

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute("href", encodeURI(csv));
        link.setAttribute("download", filename);
        link.click();
    }, [data]);

    const downloadPDF = useCallback(() => {
        const doc = new jsPDF("landscape");

        const tableColumn = [
            "Driver Id",
            "Name",
            "Total Assigned",
            "Confirmed Pickup",
            "Failed Pickup",
            "Total Unpaid",
            "Total Paid",
            "Unpaid Amount",
            "Paid Amount",
            "Discount Amount",
            "Total Amount"
        ];

        const tableRows = data.map((row) => [
            row?.driver_id,
            row?.name,
            row?.total_assigned,
            row?.total_confirmed,
            row?.total_failed,
            row?.total_unpaid,
            row?.total_paid,
            (parseFloat(row?.total_amount || 0) - parseFloat(row?.total_paid_amount || 0)).toFixed(2),
            parseFloat(row?.total_paid_amount || 0).toFixed(2),
            parseFloat(row?.total_discount_amount || 0).toFixed(2),
            parseFloat(row?.total_amount || 0).toFixed(2)
        ]);

        doc.text("Driver Report", 14, 15);

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            headStyles: {
                fillColor: [0, 41, 98],
                textColor: 255
            }
        });

        doc.save("driver-report.pdf");
    }, [data]);

    return (<>
        <Button className="TableAddBU" style={{ width: "auto" }} onClick={() => downloadPDF()}>Export To PDF</Button>
        <Export onExport={() => downloadCSV()} />
    </>);
}

const DriverReports = () => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const [filterDate, setFilterDate] = useState(null);
    const [contentLoading, setContentLoading] = useState(true);

    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    useEffect(() => {
        fetchOrders();
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (page === 0) {
            fetchOrders();
        } else {
            setPage(0);
        }
    }, [searchKey, filterDate]);

    const fetchOrders = () => {
        axios.get(process.env.REACT_APP_API_URL + "v1/report/driver-report", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            },
            params: {
                page: page + 1,
                per_page: rowsPerPage,
                search: searchKey,
                start_date: filterDate ? dayjs(filterDate[0]).format("YYYY-MM-DD") : null,
                end_date: filterDate ? dayjs(filterDate[1]).format("YYYY-MM-DD") : null,
            }
        }).then((response) => {
            setContentLoading(false);

            setAllData(response.data.data.data);
            setTotalCount(response.data.data.total);
        }).catch(() => {
            setContentLoading(false);
        });
    }

    return (<>
        <div className={`${styles.MainDiv}`}>
            <div className={`${styles.MainCard}`}>
                {contentLoading && <TableLoader />}

                {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
                    <p className={`${styles.PageTitle}`}>Driver Reports</p>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Reports</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>Driver Reports</li>
                        </ol>
                    </nav>
                </div>)}
                {!contentLoading && (<>
                    <div className="TableFilterHead">
                        <div className="DataTableSearch">
                            <Search className="SearchIcon" />
                            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                            {searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setSearchKey("")}><Close /></Button>)}
                        </div>
                        <div className={`${styles.FilterCard} Filter`}>
                            <div className={`${styles.DashFilterSec} DashFilterSec`}>
                                <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} value={filterDate} showOneCalendar onChange={(e) => setFilterDate(e)} />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.FilerButton} TableFilterBUSec`}>
                        <ButtonArea style={{ float: "right" }} data={allData}></ButtonArea>
                    </div>

                    <div className="CusTable">
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <StyledMainTableCell>Driver Id</StyledMainTableCell>
                                        <StyledMainTableCell>Name</StyledMainTableCell>
                                        <StyledMainTableCell>Total Assigned Up</StyledMainTableCell>
                                        <StyledMainTableCell>Confirmed Pickup</StyledMainTableCell>
                                        <StyledMainTableCell>Failed Pickup</StyledMainTableCell>
                                        <StyledMainTableCell>Total Unpaid</StyledMainTableCell>
                                        <StyledMainTableCell>Total Paid</StyledMainTableCell>
                                        <StyledMainTableCell>Unpaid Amount</StyledMainTableCell>
                                        <StyledMainTableCell>Paid Amount</StyledMainTableCell>
                                        <StyledMainTableCell>Discounted Amount</StyledMainTableCell>
                                        <StyledMainTableCell>Total Amount</StyledMainTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {allData.map((item, index) => {
                                        return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <TableCell component="th" scope="row">{item?.driver_id}</TableCell>
                                            <TableCell component="th" scope="row">{item?.name}</TableCell>
                                            <TableCell component="th" scope="row">{item?.total_assigned}</TableCell>
                                            <TableCell component="th" scope="row">{item?.total_confirmed}</TableCell>
                                            <TableCell component="th" scope="row">{item?.total_failed}</TableCell>
                                            <TableCell component="th" scope="row">{item?.total_unpaid}</TableCell>
                                            <TableCell component="th" scope="row">{item?.total_paid}</TableCell>
                                            <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.total_amount) - parseFloat(item?.total_paid_amount))}</TableCell>
                                            <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.total_paid_amount))}</TableCell>
                                            <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.total_discount_amount))}</TableCell>
                                            <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.total_amount))}</TableCell>
                                        </StyledMainTableRow>);
                                    })}

                                    {allData.length === 0 && (<TableRow>
                                        <TableCell colSpan={6} align="center">No data found</TableCell>
                                    </TableRow>)}

                                </TableBody>
                                {totalCount > 0 && (<TableFooter>
                                    <TableRow>
                                        <TablePaginationComponent
                                            count={totalCount}
                                            colSpan={6}
                                            page={page}
                                            rowsPerPage={rowsPerPage}
                                            handleChangePage={paginationChangePage}
                                            handleChangeRowsPerPage={paginationChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                                )}
                            </Table>
                        </TableContainer>
                    </div>
                </>)}
            </div>
        </div>
    </>);
};

export default withAdminAuth(DriverReports);